import axios from "axios";

// lsq lapp names for different cases
const lappNames = {
  OTP: "da_46725_9f5d7299",
  CREATE: "da_46725_c0ebcc55",
  MAVIS: "da_46725_b19b105f",
  CIBIL: "da_46725_2fb2df8c",
  CUSTOMER_SEARCH: "da_46725_a9bdc684",
  UPDATE_LEAD: "da_46725_89cae1b0",
  HIRECRAFT: "da_46725_1e8e839f",
  CRIF: "da_46725_db9e18ed",
};

// lsq base URL
const LSQ_BASE_URL =
  "https://pstech.leadsquaredapps.com/lapp-proxy";

// call lsq api
export const callLSQLapp = async (payload, lappType, param) => {
  try {
    console.log("payload, lappType, param", { payload, lappType, param });
    // create payload
    let proxyPayload = {
      method: "post",
      orgId: "46725",
      params: {
        stage: "Live",
        name: lappNames[lappType],
      },
      data: {
        lappBody: payload,
      },
    };

    // add params
    if (param) {
      const mergedObject = Object.assign({}, proxyPayload.params, param);
      proxyPayload.params = mergedObject;
    }
    // console.log("proxyPayload", proxyPayload);
    const res = await axios.post(LSQ_BASE_URL, proxyPayload);
    return res;
  } catch (error) {
    console.log("callLSQLapp error", error);
  }
};

export function getLsqLeadBody(formData, TypeOfLoan) {
  let Config = {
    subProduct: "mx_Subcategory_product",
    pincode: "mx_Pincode",
    token: "mx_Token",
    DateOfBirthValue: "mx_Date_of_Birth",
    fullname: "FirstName",
    email: "EmailAddress",
    mobile: "Mobile",
    profession: "mx_Employment_Type",
    salary: "mx_Take_Home_Salary",
    // minloanamt: "mx_HL_Required_Loan_Amount",
    ApiProductName: "mx_Product",
    terms_chk: "mx_Iauthorization",
    // ExistingObligations: "mx_Obligation_Amount",
    MonthlyIncome: "mx_Gross_Monthly_Income",
    salary_mode: "mx_Salary_Received_in_Cash",
    LoanTenure: "mx_Tenure_in_Years",
    co_applicant: "mx_CoApplicant",
    co_applicant_salary: "mx_Co_Applicant_Salary",
    utm_term: "mx_Utm_Terms",
    utm_lms: "mx_utm_lms",
    utm_campaign: "SourceCampaign",
    utm_content: "SourceContent",
    loanamount: "mx_HL_Required_Loan_Amount",
    Obligation: "mx_Obligation_Amount",
    GrossFamilyIncome: "mx_Gross_Family_Income",

    PurposeOfLoan: "mx_Purpose",

    CityName: "mx_City",
    EducationQualification: "mx_HighestEducation_Qualification",
    CompanyName: "mx_Company_name",

    DND: "mx_DND_NDNC",
    COMPANY_LOCATION: "mx_Customer_Location",

    Age: "mx_Age",
    gclid: "mx_Gclid",
    Referral: "mx_Referral",
    InterestRate: "mx_Interest_Rate",
    FOIR: "mx_FOIR",
    IsEligible: "mx_Eligible",
    EligibilityReason: "mx_Eligibility_Reason",
    // EmiPerLakh: "mx_Offer_EMI",
    CompleteUrl: "mx_UTM_URL_Details",
    calTenure: "mx_Current_EMI",
    ApproximateCostOfProperty: "mx_Property_Value",
    // RequiredLoanAmount: "mx_Loan_Amount",
    PropertyIdentified: "mx_Property_Identified",
    CampaignId: "mx_Campaign_ID",
    ParentProduct: "mx_Parent_Product",
    displayLoanAmount: "mx_Offer_Amount",
    displayTenure: "mx_Current_EMI",
    displayEmiPayable: "mx_Offer_EMI",
    displayRate: "mx_Offer_Rate_of_Interest",
    cibilscore: "mx_cibil_score",
    incomeSegment: "mx_income_segment_score",
    reportId: "mx_Criff_Report_ID",
    FBClickID: "mx_FB_Click_ID",
    FBPixelID: "mx_FB_Pixel_ID",
    CriffTriggered: "mx_Criff_Triggered",
    criffResponse: "mx_Criff_Response_Message",
    // Pancard:"mx_PAN"

    User_Agent: "mx_Lead_Device",

    CompanyType: "mx_Company_Type",
    ModeOfLead: "Source",
    utm_medium: "SourceMedium",
    utm_source: "mx_Source_UTM",
    pan: "mx_PAN",
  };
  let LeadBody = [];
  // if (TypeOfLoan == "HL") {
  Object.keys(Config).forEach((key) => {
    if (formData.hasOwnProperty(key) && formData[key])
      LeadBody.push({
        Attribute: Config[key],
        Value: formData[key],
      });
  });
  // }
  return LeadBody;
}

export const DataLayerEvent = async (
  email,
  mobileNum,
  event,
  eventCategory,
  eventAction,
  eventLabel,
  bounceRateTracking
) => {
  console.log(`datalayer event - ${eventLabel}`);
  window.dataLayer = window.dataLayer || [];
  let dataLayerObject = {
    event: event,
    eventCategory: eventCategory,
    eventAction: eventAction,
    eventLabel: eventLabel,
  };
  if (!bounceRateTracking) {
    dataLayerObject["email"] = email;
    dataLayerObject["mobile"] = mobileNum;
  }
  window.dataLayer.push(dataLayerObject);
};

export const setValuesInLocalStorange = async (email, mobile) => {
  var data = {
    email,
    mobile,
  };
  // Convert the data to a JSON string
  var jsonData = JSON.stringify(data);

  // Store the JSON string in local storage
  localStorage.setItem("userData", jsonData);
};

export const getValuesInLocalStorange = async (keyName) => {
  // Retrieve the JSON string from local storage
  var storedData = localStorage.getItem(keyName);

  // Parse the JSON string back into an object
  var retrievedData = JSON.parse(storedData);

  console.log("retrievedData", retrievedData);
  return retrievedData;
};

// // Main encryption function
// export const encryptBody = async (payload) => {
//   // Generate session key and IV
//   const sessionKey = generateRandomNumber(16);
//   const iv = generateRandomNumber(16);

//   // Encrypt the session key with RSA using node-forge
//   const publicKeyPem = process.env.REACT_APP_ICICI_PUBLIC_KEY;
//   // console.log(publicKeyPem, "publicKeyPem");

//   const publicKey = forge.pki.publicKeyFromPem(publicKeyPem);
//   const encryptedSessionKey = forge.util.encode64(
//     publicKey.encrypt(sessionKey, 'RSAES-PKCS1-V1_5')
//   );

//   // Prepare and encrypt the data payload
//   const data = iv + JSON.stringify(payload);
//   const encryptedData = encryptData(data, sessionKey, iv);

//   // Construct the final encrypted response object
//   return {
//     requestId: '',
//     service: '',
//     encryptedKey: encryptedSessionKey,
//     oaepHashingAlgorithm: 'NONE',
//     iv: '',
//     encryptedData,
//     clientInfo: '',
//     optionalParam: ''
//   };
// };

// // Helper function to generate a random numeric string of a given length
// const generateRandomNumber = (length) => {
//   return Array.from({ length }, () => Math.floor(Math.random() * 10)).join('');
// };

// // AES encryption function using crypto-js
// const encryptData = (value, sessionKey, iv) => {
//   const encrypted = CryptoJS.AES.encrypt(
//     value,
//     CryptoJS.enc.Utf8.parse(sessionKey),
//     { iv: CryptoJS.enc.Utf8.parse(iv), mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
//   );
//   return encrypted.toString();
// };

// Generate Random String for Session Key and IV
const generateRandomString = (length) => {
  const array = new Uint8Array(length);
  window.crypto.getRandomValues(array);
  return Array.from(array, (byte) => ("0" + (byte % 256)).slice(-2))
    .join("")
    .slice(0, length);
};

// RSA Encryption Function with Dynamic Public Key Fetch
const rsaEncryptSessionKey = async (sessionKey) => {
  try {
    const publicKeyPem = process.env.REACT_APP_ICICI_PUBLIC_KEY;
    if (!publicKeyPem) {
      throw new Error("Public key not found in environment variables");
    }

    // Convert PEM to CryptoKey
    const publicKey = await crypto.subtle.importKey(
      "spki",
      pemToArrayBuffer(publicKeyPem),
      {
        name: "RSA-OAEP",
        hash: "SHA-256",
      },
      true,
      ["encrypt"]
    );

    // Encrypt the session key
    const encryptedKey = await crypto.subtle.encrypt(
      { name: "RSA-OAEP" },
      publicKey,
      new TextEncoder().encode(sessionKey)
    );

    return bufferToBase64(encryptedKey);
  } catch (error) {
    console.error("Failed to load or encrypt with public key:", error);
    throw error;
  }
};

// AES Encryption Function using Web Crypto API
const aesEncrypt = async (data, sessionKey, iv) => {
  // Convert session key and IV to ArrayBuffer
  const key = await crypto.subtle.importKey(
    "raw",
    new TextEncoder().encode(sessionKey),
    { name: "AES-CBC" },
    false,
    ["encrypt"]
  );

  const encryptedData = await crypto.subtle.encrypt(
    {
      name: "AES-CBC",
      iv: new TextEncoder().encode(iv),
    },
    key,
    new TextEncoder().encode(data)
  );

  return new Uint8Array(encryptedData);
};

// Utility: Convert PEM to ArrayBuffer
function pemToArrayBuffer(pem) {
  const base64 = pem.replace(
    /-----BEGIN PUBLIC KEY-----|-----END PUBLIC KEY-----|\n/g,
    ""
  );
  const binary = atob(base64);
  const buffer = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    buffer[i] = binary.charCodeAt(i);
  }
  return buffer.buffer;
}

// Utility: Convert ArrayBuffer to Base64
function bufferToBase64(buffer) {
  const bytes = new Uint8Array(buffer);
  return btoa(String.fromCharCode.apply(null, bytes));
}

// Main Encryption Function that can be called externally
export const encryptBody = async (payload) => {
  const sessionKey = generateRandomString(16); // 16-byte session key
  const iv = generateRandomString(16); // 16-byte IV for AES

  // Encrypt session key with RSA using the fetched public key
  const encryptedSessionKey = await rsaEncryptSessionKey(sessionKey);

  // Encrypt the payload with AES
  const encryptedDataArrayBuffer = await aesEncrypt(
    JSON.stringify(payload),
    sessionKey,
    iv
  );

  // Combine IV with encrypted data
  const encryptedData = new Uint8Array(
    16 + encryptedDataArrayBuffer.byteLength
  );
  encryptedData.set(new TextEncoder().encode(iv), 0); // First 16 bytes are IV
  encryptedData.set(new Uint8Array(encryptedDataArrayBuffer), 16); // Rest is encrypted data

  // Return the encrypted session key and data
  return {
    requestId: "",
    service: "",
    encryptedKey: encryptedSessionKey,
    encryptedData: bufferToBase64(encryptedData),
    oaepHashingAlgorithm: "NONE",
    iv: "",
    clientInfo: "",
    optionalParam: "",
  };
};
